import { v4 as uuid } from 'uuid';
import cx from 'classnames';
import { CatSkeleton } from '@blocks-react/components/Skeleton';
import { EquipmentInfoLoader } from './equipment-Info-loader';
import { EquipmentDescriptionLoader } from './equipment-description-loader';
import { useBreakpoint } from '../../../../hooks';
import { PAGE_BREAKPOINTS } from '../../../../constants/commonConstants';
import styles from './service-insight-loader.module.scss';

export const ServiceInsightLoader = () => {
  const isDesktop = useBreakpoint(PAGE_BREAKPOINTS.LG);
  const isTablet = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const loaderCount = Array.from({
    length: isDesktop ? 4 : 1
  });

  return loaderCount.map((_, index) => {
    return (
      <div className={cx("pb-2 pb-md-3 py-lg-0", {
        "row":isDesktop,
        "cat-u-padding-top-xl":isTablet && !isDesktop,
        "cat-u-padding-top-lg": !isTablet && !isDesktop
      })} key={uuid()}>
        {!isDesktop && (
          <CatSkeleton
            width="155px"
            className={cx('d-block', styles['service-insight-title'])}
          />
        )}
        <div
          className={cx("ps-lg-0",{
            'mt-2 w-100': !isDesktop,
            [styles['service-insight-loader']]: !isDesktop,
            [styles['service-insight-desktop-loader']]: isDesktop
          })}
        >
          <div
            className={cx(
              'd-flex flex-md-column-reverse flex-lg-row row-gap-md-2 row-gap-lg-0 align-items-lg-center column-gap-lg-3 mr-lg-3 py-2 py-md-0 ps-lg-0',
              {
                [styles['service-insight-desktop-loader__wrapper']]: isDesktop,
                [styles['service-insight-loader__wrapper']]: !isDesktop,
                'mt-lg-3': loaderCount.length - 1 === index,
                'my-lg-3': loaderCount.length - 1 !== index
              }
            )}
          >
            <div
              className={cx({
                'w-25': isDesktop,
                'w-50': isTablet && !isDesktop,
                'w-100': !isDesktop && !isTablet
              })}
            >
              <EquipmentInfoLoader />
            </div>
            <EquipmentDescriptionLoader />
          </div>
        </div>
      </div>
    );
  });
};
